import { axiosInstance } from 'utils/http';
import { showAlert } from 'redux/actions/AlertActions';
import { snowflakeAccountUsage } from 'utils/urlConstants';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchSnowflakeAccountMetadata = ({ environmentFilter } = {}) => {
  const dispatch = useDispatch();

  return useQuery(
    ['snowflakeAccountMetadata', environmentFilter],
    () => axiosInstance.get(snowflakeAccountUsage.snowflakeAccountMetadata, {
      params: {
        ...(environmentFilter && { environmentFilter }),
      },
    }),
    {
      retry: false,
      enabled: !!environmentFilter, // don't run unless environmentFilter is provided
      select: (res) => res?.data?.accountNames ?? [],
      onError: () => {
        dispatch(showAlert({
          message: 'Failed to fetch snowflake account metadata',
          type: 'error',
        }));
      },
    },
  );
};
